// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-navigation-template/src/index.tsx

import baseIcon, { navigationDefaultStyleSheetGetter, defaultNavigationIconGroupProps, defaultNavigationIconShapeSize } from '@bubble-ui/temp-icon-base';
var NavigationIconInvestmentFundPath = 'M5 3h13.806l5.895 4.705V27H5V3Zm2.19 2.19v19.62H22.51V11.082h-5.726V5.19H7.19ZM22.51 8.759v.133h-3.536V5.936L22.51 8.76Zm-10.093 9.903H9.986v3.648h2.432v-3.648Zm1.216-5.287h2.433v8.935h-2.433v-8.935Zm6.08 2.855h-2.431v6.08h2.432v-6.08Z';
var NavigationIconInvestmentFund = baseIcon('NavigationIconInvestmentFund', {
  getPath: () => NavigationIconInvestmentFundPath,
  defaultStyleSheetGetter: navigationDefaultStyleSheetGetter,
  groupProps: defaultNavigationIconGroupProps,
  shapeSize: defaultNavigationIconShapeSize
});
export default NavigationIconInvestmentFund;
//# sourceMappingURL=index.js.map